import { useState } from "react";
import styles from "./ChangelogView.module.scss";
import { View, ViewHeader } from "@/components";
import type {
  ChangelogPeriodFilter,
  ChangelogToolbarTab,
  ChangelogTrackFilter,
} from "../../_constants/changelog-toolbar.const";
import { ChangelogToolbar } from "../changelog-toolbar";

export const ChangelogView = () => {
  const [tab, setTab] = useState<ChangelogToolbarTab>("all");
  const [period, setPeriod] = useState<ChangelogPeriodFilter>("all");
  const [track, setTrack] = useState<ChangelogTrackFilter>("all");

  return (
    <View>
      <div className={styles["comp__content"]}>
        <ViewHeader
          heading="Changelog"
          description="Follow product updates, API changes, and release notes in one place.<br />Filter by category and time window, then export for sharing."
        />

        <ChangelogToolbar
          tab={tab}
          period={period}
          track={track}
          onTabChange={setTab}
          onPeriodChange={setPeriod}
          onTrackChange={setTrack}
          onExportClick={() => undefined}
        />

        <p className={styles["comp__empty"]}>No entries yet.</p>
      </div>
    </View>
  );
};
